import { type Question } from '@/types'

export const findMatrixRowByFormIndex = (
  questions: Question[],
  rowFormIndex: number
) => {
  for (const question of questions) {
    if (question?.question_type?.question_type === 'matrix') {
      const targetRow = question.question_rows?.find(
        (row) => Number(row.form_index) === Number(rowFormIndex)
      )
      if (targetRow) return targetRow
    }
  }
  return null
}
